<template>
    <div>
        <div :class="[inputClass, title ? 'row form-group' : '']" v-if="type === 'text'">
            <label class="form-label col-6 font-weight-bold" v-if="title" :for="namekey"
                >{{ title }}:</label
            >
            <input
                class="form-control form-control-sm"
                :class="title ? 'col-6' : ''"
                type="text"
                :disabled="disabled"
                :ref="namekey"
                :id="namekey"
                :value="value"
                :placeholder="placeholder ? placeholder : null"
                @focus="$emit('focus', namekey)"
                @input="$emit('input', $event.target.value)"
            />
        </div>
        <div :class="[inputClass, title ? 'row form-group' : '']" v-if="type === 'number'">
            <label class="form-label col-6 font-weight-bold" v-if="title" :for="namekey"
                >{{ title }}:</label
            >
            <input
                class="form-control form-control-sm"
                :class="title ? 'col-6' : ''"
                type="text"
                :disabled="disabled"
                :ref="namekey"
                :id="namekey"
                :value="value"
                :placeholder="placeholder ? placeholder : null"
                @focus="$emit('focus', namekey)"
                @input="handleNumber($event.target.value)"
            />
        </div>
        <div :class="[inputClass, title ? 'row form-group' : '']" v-if="type === 'date'">
            <label class="form-label col-6 font-weight-bold" v-if="title" :for="namekey"
                >{{ title }}:</label
            >
            <v-date-picker
                class="form-control form-control-sm"
                :class="title ? 'col-6' : ''"
                popover-align="right"
                :disabled="disabled"
                :ref="namekey"
                :id="namekey"
                :value="value"
                @focus="$emit('focus', namekey)"
                @input="$emit('input', $event)"
            ></v-date-picker>
        </div>
        <div :class="[inputClass, title ? 'row form-group' : '']" v-if="type === 'file'">
            <label class="form-label col-6 font-weight-bold" v-if="title" :for="namekey"
                >{{ title }}:</label
            >
            <input
                class="col-6 form-control form-control-file"
                type="file"
                :disabled="disabled"
                :ref="namekey"
                :id="namekey"
                @focus="$emit('focus', namekey)"
                @change="handleUpload(name)"
            />
            {{ value }}
        </div>
        <div :class="[inputClass, title ? 'row form-group' : '']" v-if="type === 'textarea'">
            <label class="form-label col-6 font-weight-bold" v-if="title" :for="namekey"
                >{{ title }}:</label
            >
            <textarea
                class="form-control form-control-sm"
                :class="title ? 'col-6' : ''"
                rows="2"
                :disabled="disabled"
                :ref="namekey"
                :id="namekey"
                :value="value"
                :placeholder="placeholder ? placeholder : null"
                @focus="$emit('focus', namekey)"
                @input="$emit('input', $event.target.value)"
            ></textarea>
        </div>
        <div :class="[inputClass, title ? 'row form-group' : '']" v-if="type === 'select'">
            <label class="form-label col-6 font-weight-bold" v-if="title" :for="namekey"
                >{{ title }}:</label
            >
            <select
                class="form-control form-control-sm"
                :class="title ? 'col-6' : ''"
                :disabled="disabled"
                :ref="namekey"
                :id="namekey"
                :value="value"
                @focus="$emit('focus', namekey)"
                @input="$emit('input', $event.target.value)"
            >
                <option
                    v-for="o in options"
                    :value="o.value"
                    :disabled="o.disabled"
                    :selected="o.selected"
                    :hidden="o.hidden"
                    >{{ o.title }}</option
                >
            </select>
        </div>
        <div :class="[inputClass, title ? 'row form-group' : '']" v-if="type === 'select-multiple'">
            <label class="form-label col-6 font-weight-bold" v-if="title" :for="namekey"
                >{{ title }}:</label
            >
            <select
                class="form-control form-control-sm"
                :class="title ? 'col-6' : ''"
                multiple
                :disabled="disabled"
                :ref="namekey"
                :id="namekey"
                @focus="$emit('focus', namekey)"
                @input="handleSelectMultiple($event)"
            >
                <option v-for="o in options" :value="o.value">{{ o.title }}</option>
            </select>
            <button
                class="btn btn-link btn-sm font-italic small"
                :class="{ 'font-weight-bold': value && value.length === options.length }"
                @click.prevent="multiSelectAll()"
            >
                Select All
            </button>
            <button
                class="btn btn-link btn-sm font-italic small"
                :class="{ 'font-weight-bold': value && value.length === 0 }"
                @click.prevent="multiSelectNone()"
            >
                Select None
            </button>
        </div>
        <div :class="[inputClass, title ? 'row form-group' : '']" v-if="type === 'radio'">
            <p class="mb-0">{{ title }}:</p>
            <div v-for="(o, i) in options" class="form-check form-check-inline">
                <input
                    class="form-control-sm mr-2"
                    type="radio"
                    :disabled="disabled"
                    :ref="namekey"
                    :id="`${o.value}${i}`"
                    :value="value"
                    :checked="value === o.value"
                    @focus="$emit('focus', namekey)"
                    @input="$emit('input', o.value)"
                />
                <label :for="`${o.value}${i}`">{{ o.title }}</label>
            </div>
        </div>
        <div :class="title ? 'row form-group' : 'form-check'" v-if="type === 'checkbox'">
            <label class="form-label col-6 font-weight-bold" v-if="title" :for="namekey"
                >{{ title }}:</label
            >
            <div v-for="(o, i) in options">
                <input
                    type="checkbox"
                    :disabled="disabled"
                    class="mr-2"
                    :id="`${o.value}${i}`"
                    :ref="namekey"
                    :value="o.value"
                    v-model="o.checked"
                    @focus="$emit('focus', namekey)"
                    @input="$emit('input', $event.target.value)"
                />
                <span :for="`${o.value}${i}`">{{ o.title }}</span>
            </div>
        </div>
        <div :class="title ? 'row form-group' : 'form-check'" v-if="type === 'bool'">
            <label class="form-label col-6 font-weight-bold" v-if="title" :for="namekey"
                >{{ title }}:</label
            >
            <input
                type="checkbox"
                :disabled="disabled"
                class="mr-2"
                :id="namekey"
                :ref="namekey"
                :value="value"
                v-model="value"
                @focus="$emit('focus', namekey)"
                @input="$emit('input', $event.target.checked)"
            />
            <span :for="namekey">{{ title }}</span>
        </div>
    </div>
</template>
<script>
export default {
    name: "MultiField",
    props: [
        "name",
        "title",
        "type",
        "value",
        "placeholder",
        "options",
        "uploadEndpoint",
        "parentKey",
        "inputClass",
        "disabled",
    ],
    computed: {
        namekey() {
            if (this.parentKey) {
                return this.name + this.parentKey;
            }
            return this.name;
        },
    },
    methods: {
        handleSelectMultiple(event) {
            const selected = Array.from(event.target.selectedOptions, o => o.value);
            this.$emit("input", selected);
        },
        multiSelectAll() {
            const selected = this.options.map(o => o.value);
            this.$emit("input", selected);
        },
        multiSelectNone() {
            this.$emit("input", []);
        },
        handleNumber(value) {
            if (parseFloat(value)) {
                this.$emit("input", parseFloat(value));
            } else {
                this.$emit("input", 0);
            }
        },
        handleUpload(fieldRef) {
            let data = new FormData();
            data.append("file", this.$refs[fieldRef].files[0]);
            data.append("key", fieldRef);
            data.append("value", this.value);
            axios
                .post(this.uploadEndpoint, data)
                .then(r => {
                    this.$emit("input", r.data.file);
                })
                .catch(function(e) {
                    console.error(e);
                });
        },
    },
};
</script>
